export default "__VITE_ASSET__DJy1dxf7__"